import styled from "@emotion/styled";

import { Container as ItemContainer } from "scmp-app/components/posties/content-homepage/health-and-happiness/health-and-happiness-item/styles";
import { OvalUpperBackground } from "scmp-app/components/posties/content-homepage/oval-background";

export const Container = styled.div`
  position: relative;
  z-index: 1;
`;

export const StyledOvalUpperBackground = styled(OvalUpperBackground)``;

export const MainContainer = styled.div`
  background: #f8ffac;
`;

export const ContentContainer = styled.div`
  position: relative;

  padding-block: 72px 90px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block-end: 130px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-end: 90px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    padding-block: 0 40px;
  }
`;

export const ItemsContainer = styled.div`
  position: relative;
  z-index: 1;

  inline-size: 100%;
  margin-block-start: 20px;
  margin-inline: auto;
  padding-block: 0;
  padding-inline: 20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 690px;
    margin-block-start: 40px;
    padding-inline: 0;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 972px;
    margin-block-start: 63px;
  }

  ${ItemContainer} + ${ItemContainer} {
    padding-block-start: 24px;
    ${props => props.theme.breakpoints.up("tablet")} {
      padding-block-start: 32px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      padding-block-start: 42px;
    }
  }
`;

export const EmojiContainer = styled.div`
  position: absolute;
  inset-block-start: 0;

  inline-size: 100%;
`;

export const EmojiBackgroundLeftContainer = styled.div`
  position: absolute;
  inset-block-start: 250px;
  inset-inline-start: 0;

  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const EmojiBackgroundRightContainer = styled.div`
  position: absolute;
  inset-block-start: 100px;
  inset-inline-end: 0;

  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const WaveBottomBackgroundContainer = styled.div`
  position: relative;

  display: block;
`;

export const PippaWithStarsImageContainer = styled.div`
  position: relative;
  inset-block-end: 57px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-block-end: 0;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-inline-end: 26px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inset-inline-end: 234px;
  }
`;

export const PippaWithStarsImage = styled.img`
  position: absolute;

  inline-size: 155px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-block-end: -8px;
    inset-inline-end: 5px;

    inline-size: 293px;
    block-size: 176px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-end: -6px;
    inset-inline-end: 100px;
  }
`;
